import React from 'react';

interface Props {
  page: number;
  pages: JSX.Element[];
}

const Steps = ({ page, pages }: Props) => {
  return <>{pages[page]}</>;
};

export default Steps;
